import React, { useState } from 'react';
import CustomContainer from '../../components/CustomContainer';
import Loader from '../../components/loader/Loader';
import { useNavigate, useParams } from 'react-router-dom';
import FunctionalTableComponent from '../../components/table/FunctionalTableComponent';
import columns from './HouseTableConfig';
import HouseCalendarButton from '../../components/lakeview/calendar/HouseCalendarButton';
import LightButton from '../../components/button/LightButton';

const HouseTablePage = (props) => {
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(false);

  const navigate = useNavigate();
  let { id } = useParams();

  return (
    <>
      <Loader loader={loader} />
      <CustomContainer title={'Domki'}>
        <FunctionalTableComponent
          shadow={false}
          title={'Lista domków'}
          columns={columns}
          header={true}
          api={'house'}
          setLoader={setLoader}
          removable={false}
          deleteModalTitle={'Usunięcie domka'}
          deleteModalDescription={'Czy na pewno chcesz usunąć domek?'}
          editable={true}
          customCreate={() => navigate('/house')}
          editAction={(id) => navigate('/house/' + id)}
          details={true}
          detailsAction={(id) => navigate('/house/' + id + '/details')}
          additionalButtons={function (row) {
            return (
              <>
                <HouseCalendarButton houseId={row.id} />
              </>
            );
          }}
          width={12}
        />
      </CustomContainer>
    </>
  );
};

export default HouseTablePage;
